import { FormattedMessage } from 'react-intl';

export default function FrontModules() {
  return (
    <section
      className="pt-8 pt-md-11 pb-md-11 bg-gradient-light-white"
      style={{ overflowX: 'hidden' }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-7 col-lg-6" data-aos="fade-right">
            <h2>
              <FormattedMessage id="front.modules.title" />
              <span className="text-primary">
                {' '}
                <FormattedMessage id="front.modules.title2" />
              </span>
              .
            </h2>
            <p className="fs-lg text-muted mb-6">
              <FormattedMessage id="front.modules.subtitle" />
            </p>
            <div className="d-flex">
              <div className="icon text-primary">
                <svg width={24} height={24} viewBox="0 0 24 24" xmlns="../www.w3.org/2000/svg.html">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path
                      d="M12 8H8a4 4 0 00-4 4v1a3 3 0 003 3v2a5 5 0 01-5-5v-1a6 6 0 016-6h4V4.728a.5.5 0 01.8-.4l2.856 2.133a.5.5 0 01-.001.802l-2.857 2.121A.5.5 0 0112 8.983V8z"
                      fill="#335EEA"
                    />
                    <path
                      d="M12.058 16H16a4 4 0 004-4v-1a3 3 0 00-3-3V6a5 5 0 015 5v1a6 6 0 01-6 6h-3.942v.983a.5.5 0 01-.798.401l-2.857-2.12a.5.5 0 010-.803l2.856-2.134a.5.5 0 01.8.401V16z"
                      fill="#335EEA"
                      opacity=".3"
                    />
                  </g>
                </svg>
              </div>
              <div className="ms-5">
                <h4 className="mb-1">
                  <FormattedMessage id="front.modules.type1" />
                </h4>
                <p className="text-muted mb-6">
                  <FormattedMessage id="front.modules.type1paragraph" />
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div className="icon text-primary">
                <svg width={24} height={24} viewBox="0 0 24 24" xmlns="../www.w3.org/2000/svg.html">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path
                      d="M17.272 8.685a1 1 0 111.456-1.37l4 4.25a1 1 0 010 1.37l-4 4.25a1 1 0 01-1.456-1.37l3.355-3.565-3.355-3.565zm-10.544 0L3.373 12.25l3.355 3.565a1 1 0 01-1.456 1.37l-4-4.25a1 1 0 010-1.37l4-4.25a1 1 0 011.456 1.37z"
                      fill="#335EEA"
                    />
                    <rect
                      fill="#335EEA"
                      opacity=".3"
                      transform="rotate(15 12 12)"
                      x={11}
                      y={4}
                      width={2}
                      height={16}
                      rx={1}
                    />
                  </g>
                </svg>
              </div>
              <div className="ms-5">
                <h4 className="mb-1">
                  <FormattedMessage id="front.modules.type2" />
                </h4>
                <p className="text-muted mb-6">
                  <FormattedMessage id="front.modules.type2paragraph" />
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div className="icon text-primary">
                <svg width={24} height={24} viewBox="0 0 24 24" xmlns="../www.w3.org/2000/svg.html">
                  <g fill="none" fillRule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path
                      d="M5.5 4h4A1.5 1.5 0 0111 5.5v1A1.5 1.5 0 019.5 8h-4A1.5 1.5 0 014 6.5v-1A1.5 1.5 0 015.5 4zm9 12h4a1.5 1.5 0 011.5 1.5v1a1.5 1.5 0 01-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-1a1.5 1.5 0 011.5-1.5z"
                      fill="#335EEA"
                    />
                    <path
                      d="M5.5 10h4a1.5 1.5 0 011.5 1.5v7A1.5 1.5 0 019.5 20h-4A1.5 1.5 0 014 18.5v-7A1.5 1.5 0 015.5 10zm9-6h4A1.5 1.5 0 0120 5.5v7a1.5 1.5 0 01-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-7A1.5 1.5 0 0114.5 4z"
                      fill="#335EEA"
                      opacity=".3"
                    />
                  </g>
                </svg>
              </div>
              <div className="ms-5">
                <h4 className="mb-1">
                  <FormattedMessage id="front.modules.type3" />
                </h4>
                <p className="text-muted mb-6 mb-md-0">
                  <FormattedMessage id="front.modules.type3paragraph" />
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-5 col-lg-6">
            <div className="w-md-150 w-lg-130 " data-aos="fade-left">
              <div className="shape shape-fluid-y shape-blur-4 text-gray-200">...</div>
              <div className="img-skewed img-skewed-start">
                <img
                  src="assets/img/screenshots/desktop/cdmis-dashboard.webp"
                  className="screenshot img-fluid img-skewed-item"
                  alt="..."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
